import React from 'react';
import Select from 'react-select';
import { Link } from 'react-router-dom';
import '../views/css/Reports.css';
// import Collapsible from 'react-collapsible';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SearchReports from './SearchReports';
import Picker from 'react-month-picker';
import 'react-month-picker/css/month-picker.css';
import $ from 'jquery';
import DashboardViews from "../views/Dashboard";

const arrowdown = (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-arrow-up-circle">
        <circle cx="12" cy="12" r="10" /><polyline points="16 12 12 8 8 12" /><line x1="12" y1="16" x2="12" y2="8" />
    </svg>
);
const options = [
    { value: 'Select Report', label: 'Select Report' },
    { value: 'external_partner_lead_detailed_report', label: 'External partner lead detail report' },
    { value: 'external_partner_lead_summary_report', label: 'External partner lead summary report' },
    { value: 'credit_lead_return_resason_report', label: 'Credit leads return reason report' },
    { value: 'interaday_external_partner_lead_detailed_report', label: 'Intraday external partner lead detail report' },
];

const daterangeOptions = [
    { value: 'Custom', label: 'Custom' },
    // { value: 'Today', label: 'Today' },
    { value: 'Yesterday', label: 'Yesterday' },
    { value: 'Last 7 days', label: 'Last 7 days' },
    { value: 'Last 30 days', label: 'Last 30 days' },
    { value: 'Last 60 days', label: 'Last 60 days' },
    { value: 'Last 90 days', label: 'Last 90 days' },
    { value: 'This week', label: 'This week' },
    { value: 'Last week', label: 'Last week' },
    { value: 'This Month', label: 'This Month' },
    { value: 'Last Month', label: 'Last Month' },
];

let medium_ = [];
let offer_Type = [];
let source_Provider;
const sites_ = [
    { value: 'Select All', label: 'Select All' },
    { value: 'All Allied Health Schools', label: 'All Allied Health Schools' },
    { value: 'All Arts Schools', label: 'All Arts Schools' },
    { value: 'All Business Schools', label: 'All Business Schools' },
]
let offertypeVal;
let mediumVal;

const get_token = localStorage.getItem("token");
// const inpersonateuserId = localStorage.getItem("inpersonate_user");
const inpersonateFlag = localStorage.getItem("inpersonate");

let report_Results = [];
class Reports extends React.Component {
    constructor() {
        super()
        this.state = {
            selectedOption: { label: 'Select Report', value: 'Select Report' },
            open: true,
            startDate: new Date(),
            endDate: new Date(),
            daterangeoption: { label: 'Yesterday', value: 'Yesterday' },
            medium: [],
            offerType: [],
            sourceProvider: '',
            sites: [],
            filterresults: true,
            selectMonth: new Date(),
            isReportVisible: false,
            reportresults: {},
            page: 1,
            pageperdata: '',
            currentPage: 1,
            loading: true,
            responsemessage: '',
            report_tab_type: 'Summary',
            reporttab_index: 0,
            error_msg: false,
            error_end_msg: false,
            number: 26,
            dashboardReport: {
                activeEle: 'Summary',
            }
        }
        this.togglePanel = this.togglePanel.bind(this);
        //    this.togglePanelSelectValue = this.togglePanelSelectValue.bind(this);
        //    this.togglePanelsearchReport = this.togglePanelsearchReport.bind(this);

    }



    handleDateChange(dateName, dateValue) {
        let { startDate, endDate } = this.state;
        if (dateName === 'startDateTime') {
            startDate = dateValue;
        } else {
            endDate = dateValue;
        }
        this.setState({
            startDate,
            endDate,
        });
        if (Date.parse(startDate) > Date.parse(endDate)) {
            this.setState({ error_msg: true });
            $('#formElem').addClass("disabled");
        }
        else {
            this.setState({ error_msg: false });
            $('#formElem').removeClass("disabled");
        }
        //   if(Date.parse(endDate) <= Date.parse(startDate)){
        //         this.setState({error_end_msg: true});
        //  }
        //  else{
        //     this.setState({error_end_msg: false});
        //   }

        console.log(`Option selected:`, startDate, endDate);
    }
    handleMonthChange(monthName, monthValue) {
        let { selectMonth } = this.state;
        if (monthName === 'selectMonth') {
            selectMonth = monthValue;
        }
        this.setState({
            selectMonth,
        });
        console.log(selectMonth);

    }
    handleChange = selectedOption => {
        this.setState({ selectedOption });
    };


    showReportshandleClick = async (e) => {
        this.setState({ isReportVisible: true, currentPage: 1, loading: true });
        //console.log(inpersonateuserId , inpersonateFlag)   
        const inpersonateUserid = localStorage.getItem("inpersonate_id");
        const userId = localStorage.getItem("userId");
        let billingYearValue = (this.state.selectMonth.getFullYear());
        let billingMonthValue = ("0" + (this.state.selectMonth.getMonth() + 1)).slice(-2);

        if (this.state.selectedOption.value != 'external_partner_lead_summary_report') {
            offertypeVal = $('.hidden-lbl.offer-type').text();
        }
        if (this.state.selectedOption.value != 'credit_lead_return_resason_report') {
            mediumVal = $('.hidden-lbl.medium-lbl').text();
        }
        let objArr =
        {
            //'get_token' : get_token,
            'report_type': this.state.selectedOption.value,
            'page_no': this.state.page
        }
        //  if (inpersonateFlag == 'true'){
        //             objArr = {...objArr, ['view_user_id'] : userId }  
        //  }    
        if (this.state.selectedOption.value == 'credit_lead_return_resason_report') {
            objArr = { ...objArr, ['tab_type']: this.state.report_tab_type }

        }
        if (this.state.selectedOption.value == 'credit_lead_return_resason_report') {
            objArr = { ...objArr, ['billing_month']: billingYearValue + billingMonthValue }

        }
        if (this.state.selectedOption.value != 'credit_lead_return_resason_report') {
            objArr = { ...objArr, ['present_date_range']: this.state.daterangeoption.value }
        }

        if (this.state.daterangeoption.value) {
            objArr = { ...objArr, ['lead_create_start']: this.state.startDate.toISOString().split('T')[0] }
            objArr = { ...objArr, ['lead_create_end']: this.state.endDate.toISOString().split('T')[0] }
        }
        if (this.state.selectedOption.value != 'credit_lead_return_resason_report') {
            if ((mediumVal.trim()) != "") {
                objArr = { ...objArr, ['medium']: mediumVal.trim() }
            }
        }
        if (this.state.selectedOption.value != 'external_partner_lead_summary_report') {
            if ((offertypeVal.trim()) != "") {
                objArr = { ...objArr, ['offer_type']: offertypeVal.trim() }
            }
        }
        console.log(JSON.stringify(objArr));

        const reportRequestOptions = {
            method: 'POST',
            mode: "cors",
            headers: {
                "Content-Type": "application/json",
                'Authorization': 'Bearer' + get_token,
            },
            body: JSON.stringify(objArr),
        }
        fetch(`./wp-json/asd/api/report`, reportRequestOptions)
            .then(response => response.json())
            .then(data => this.setState({ reportresults: data, pageperdata: data.data.length, loading: false, }))
            .catch(response => {
                this.setState({ responsemessage: "Something Went's wrong. Please try again", loading: false });
            });
        $('.selectvalue-filter').removeClass("hide-filter");
        $('.searchReport').removeClass("hide-filter");

    };

    presentDatehandleChange = daterangeoption => {
        this.setState({ daterangeoption });
        let { startDate, endDate } = this.state;
        if (daterangeoption.value == 'Custom') {
            $('.datepicker').removeClass("disabled");
            this.setState({ startDate: new Date(), endDate: new Date() })
        }
        else if (daterangeoption.value == 'Today') {
            this.setState({ error_msg: false });
            $('#formElem').removeClass("disabled");
            $('.datepicker').addClass("disabled");
            this.setState({ startDate: new Date(), endDate: new Date() })
        }
        else if (daterangeoption.value == 'Yesterday') {
            this.setState({ error_msg: false });
            $('#formElem').removeClass("disabled");
            let y_date = new Date(new Date().setDate(new Date().getDate() - 1));
            $('.datepicker').addClass("disabled");
            this.setState({ startDate: y_date, endDate: y_date })

        }
        else if (daterangeoption.value == 'Last 7 days') {
            this.setState({ error_msg: false });
            $('#formElem').removeClass("disabled");
            let lastseven_date = new Date(new Date().setDate(new Date().getDate() - 7));
            $('.datepicker').addClass("disabled");
            this.setState({ startDate: lastseven_date, endDate: new Date(new Date().setDate(new Date().getDate() - 1)) })
        }
        else if (daterangeoption.value == 'Last 30 days') {
            this.setState({ error_msg: false });
            $('#formElem').removeClass("disabled");
            let lastthirty_date = new Date(new Date().setDate(new Date().getDate() - 30));
            $('.datepicker').addClass("disabled");
            this.setState({ startDate: lastthirty_date, endDate: new Date(new Date().setDate(new Date().getDate() - 1)) })
        }
        else if (daterangeoption.value == 'Last 60 days') {
            this.setState({ error_msg: false });
            $('#formElem').removeClass("disabled");
            let lastthirty_date = new Date(new Date().setDate(new Date().getDate() - 60));
            $('.datepicker').addClass("disabled");
            this.setState({ startDate: lastthirty_date, endDate: new Date(new Date().setDate(new Date().getDate() - 1)) })
        }
        else if (daterangeoption.value == 'Last 90 days') {
            this.setState({ error_msg: false });
            $('#formElem').removeClass("disabled");
            let lastninty_date = new Date(new Date().setDate(new Date().getDate() - 90));
            $('.datepicker').addClass("disabled");
            this.setState({ startDate: lastninty_date, endDate: new Date(new Date().setDate(new Date().getDate() - 1)) })
        }
        else if (daterangeoption.value == 'This week') {
            this.setState({ error_msg: false });
            $('#formElem').removeClass("disabled");
            var curr = new Date;
            var firstday = new Date(curr.setDate(curr.getDate() - curr.getDay()));
            var lastday = new Date(curr.setDate(curr.getDate() - curr.getDay() + 6));
            $('.datepicker').addClass("disabled");
            this.setState({ startDate: firstday, endDate: new Date(new Date().setDate(new Date().getDate() - 1)) })
        }
        else if (daterangeoption.value == 'Last week') {
            this.setState({ error_msg: false });
            $('#formElem').removeClass("disabled");
            var beforeOneWeek = new Date(new Date().getTime() - 60 * 60 * 24 * 7 * 1000)
            var beforeOneWeek2 = new Date(beforeOneWeek);
            var day = beforeOneWeek.getDay() + 1;
            console.log(day);
            var diffToMonday = beforeOneWeek.getDate() - day + (day === 0 ? -6 : 1);
            var lastMonday = new Date(beforeOneWeek.setDate(diffToMonday))
            var lastSunday = new Date(beforeOneWeek2.setDate(diffToMonday + 6));
            $('.datepicker').addClass("disabled");
            this.setState({ startDate: lastMonday, endDate: lastSunday })
        }
        else if (daterangeoption.value == 'This Month') {
            this.setState({ error_msg: false });
            $('#formElem').removeClass("disabled");
            var date = new Date();
            var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
            var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            this.setState({ startDate: firstDay, endDate: new Date(new Date().setDate(new Date().getDate() - 1)) });
            $('.datepicker').addClass("disabled");
        }
        else if (daterangeoption.value == 'Last Month') {
            this.setState({ error_msg: false });
            $('#formElem').removeClass("disabled");
            var now = new Date();
            var lastday = new Date(now.getFullYear(), now.getMonth(), 0);
            var firstday = new Date(lastday.getFullYear(), lastday.getMonth(), 1);
            this.setState({ startDate: firstday, endDate: lastday });
            $('.datepicker').addClass("disabled");
        }
        else {
            $('.datepicker').addClass("disabled");
            $('.custom-date-lbl').addClass('lbl-hide');

        }

    };

    mediumhandleChange = (medium) => {
        this.setState({ medium });

    };
    offertypehandleChange = (offerType) => {
        this.setState({ offerType });
    };

    sourceProviderhandleChange = sourceProvider => {
        this.setState({ sourceProvider })
    };
    siteshandleChange = (sites) => {
        this.setState({ sites });
    };
    togglePanel(e) {
        this.setState({ open: !this.state.open })
    }

    componentDidMount() {
        if (2 === this.props.SelectedTab) {
            const get_token = localStorage.getItem("token");
            const userId = localStorage.getItem("userId");
            const inpersonateUserid = localStorage.getItem("inpersonate_id");

            const requestOptions = {
                method: "GET",
                mode: "cors",
                headers: {
                    'Authorization': 'Bearer' + get_token,
                },
            };
            const tokenrequestOtions = {
                method: "POST",
                mode: "cors",
                headers: {
                    'Authorization': 'Bearer' + get_token,
                },
            };

            fetch(`./wp-json/asd/api/offer_type`, requestOptions)
                .then(response => response.json())
                .then(data => { offer_Type = data.data })



            fetch(`./wp-json/asd/api/medium`, tokenrequestOtions)
                .then(response => response.json())
                .then(data => { console.log(userId); medium_ = data.data; })


            if (inpersonateFlag == 'true') {
                const inpersonateUser = localStorage.getItem("inpersonate_user");
                const inpersonateUserid = localStorage.getItem("inpersonate_id");
                console.log(inpersonateUserid);
                const sourcerequestOptions = {
                    method: 'POST',
                    mode: 'cors',
                    body: JSON.stringify({ id: inpersonateUserid, token: get_token }),
                };
                fetch(`./wp-json/asd/users/get`, sourcerequestOptions)
                    .then(response => response.json())
                    .then(data => { source_Provider = data.user_code; this.setState({ sourceProvider: source_Provider }) });
            }
            else {
                if (userId !== '' && userId !== null) {
                    const sourcerequestOptions = {
                        method: 'POST',
                        mode: 'cors',
                        body: JSON.stringify({ id: userId, token: get_token }),
                    };
                    fetch(`./wp-json/asd/users/get`, sourcerequestOptions)
                        .then(response => response.json())
                        .then(data => { source_Provider = data.user_code; this.setState({ sourceProvider: source_Provider }) });
                }
            }
            // if (inpersonateuserId !== '' && inpersonateuserId !== null) {
            //     const sourcerequestOptions = {
            //         method: 'POST',
            //         mode: 'cors',
            //         body: JSON.stringify({id: inpersonateuserId, token: get_token}),
            //     };
            //     fetch(`./wp-json/asd/users/get`, sourcerequestOptions)
            //         .then(response => response.json())
            //         .then(data => {console.log(data);source_Provider = data.user_role;this.setState({sourceProvider: source_Provider})});
            // }

        }

        if (this.props.selectedreport != '') {
            this.setState({ selectedOption: this.props.selectedreport });
            if (this.props.reportdateOption == true) {
                if (this.props.selectedreport.value == 'interaday_external_partner_lead_detailed_report' || 'intraday_linkout_lead_detail_report') {
                    var daterangeoptio = { label: 'Today', value: 'Today' };
                    this.setState({ daterangeoption: daterangeoptio });
                }
                else {
                    var daterangeoptio = { label: 'Yesterday', value: 'Yesterday' };
                    this.setState({ daterangeoption: daterangeoptio });
                    let y_date = new Date(new Date().setDate(new Date().getDate() - 1));
                    $('.datepicker').addClass("disabled");
                    this.setState({ startDate: y_date, endDate: y_date })
                    // $(".filter-main-sct").removeClass("hide-bk");
                }
                // $('.selectvalue-filter').addClass("hide-filter");
                // $('.searchReport').addClass("hide-filter");

            }
        }

    }


    componentWillReceiveProps() {
        this.setState({ selectedOption: this.props.selectedreport });
        console.log(this.state.selectedOption + "d");

    }
    subscribebtn = () => {
        window.location.href = './myaccount';
        localStorage.setItem('profiletab', 1);
        localStorage.setItem('SaveSubscription', 1);
        localStorage.removeItem('subscribeedit_id');
        // React.useEffect(() => {
        //     const tabactive = Number(localStorage.getItem("profiletab") || 0)
        //     setValue(tabactive);
        //   }, [])
    }
    render() {
        const { selectedOption, daterangeoption, medium, offerType, sourceProvider, startDate, endDate, sites } = this.state;
        const { open } = this.state;
        let InpersonateButton;
        const inpersonateUser = localStorage.getItem("inpersonate_user") ? localStorage.getItem("inpersonate_user") : '';
        //const inpersonateUserId = localStorage.getItem("inpersonate_id") ? localStorage.getItem("inpersonate_id") : '';
        console.log("inpersonateFlag" + inpersonateUser, inpersonateFlag);
        if (inpersonateFlag === 'true') {
            InpersonateButton = () => {
                return (
                    ''
                    //  <div className="inpersonate-user-section">
                    //    <button onClick={handleBacktoLoginUser} className="back-btn bg-orange hover:bg-gray-100 text-gray-800 font-semibold border border-gray-400 rounded shadow text-white" data-impersonation="false" id="2">
                    //      <svg className="MuiSvgIcon-root jss67 back-icon" focusable="false" viewBox="0 0 24 24" aria-hidden="true" tabIndex="-1" title="ArrowBackIos" data-ga-event-category="material-icons" data-ga-event-action="click" data-ga-event-label="ArrowBackIos"><path d="M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"></path></svg>
                    //      <span className="inpersonate-name">Back to regular user</span>
                    //    </button>
                    //    <span className="user-btn markdown-body reset text-gray-800 font-semibold border border-gray-400 rounded shadow">
                    //      <svg className="MuiSvgIcon-root jss373 person" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation" tabIndex="-1" title="People"><path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"></path></svg>
                    //      <span className="name">{inpersonateUser}</span></span>
                    //  </div>


                );
            }
        } else {
            InpersonateButton = () => {
                return ""
            }
        }

        const handleBacktoLoginUser = (event, newValue) => {
            if (event.currentTarget.attributes.getNamedItem('data-impersonation').value === "true") {
                localStorage.setItem('inpersonate', true);
            } else {
                localStorage.setItem('inpersonate', false);
            }
            const get_token = localStorage.getItem("token");
            const user_id = localStorage.getItem("userId");
            const requestOptions = {
                method: "POST",
                mode: "cors",
                body: JSON.stringify({ get_token: get_token, user_id: user_id })
            };
            if (event.currentTarget.id != '') {

                fetch(`./wp-json/asd/users/inpersonate`, requestOptions)
                    .then(response => response.json())
                    .then(userData => {
                        if (
                            "jwt_auth_invalid_token" === userData.code ||
                            "jwt_auth_bad_iss" === userData.code
                        ) {
                            localStorage.removeItem("token");
                            window.location.href = "/asd-login";
                        } else if ("jwt_auth_bad_request" === userData.code) {
                            if (userData.message) {
                                alert(userData.message);
                            }
                        } else if (userData != null) {
                            if (userData.token != null) {
                                localStorage.setItem('token', userData.token);
                                window.location.href = './';
                            }
                        }
                    });
            }
        };

        return (
            <div className="reports-wrapper">
                <div className="row-wrapper">
                    <div className="dropdownrow">
                        <div className="dropdown-blk">
                            {/* <Select
                              
                                onChange={this.handleChange}
                                options={options}
                                className="custom-select"
                              
                                defaultValue={selectedOption}
                            /> */}
                        </div>
                        <div className="pt-6 mt-3 float-right inpersonate-user"><InpersonateButton /></div>
                    </div>
                </div>
                {selectedOption.value != 'Select Report' ?
                    <div className="filter-main-sct">

                        <div className="filter-collapse">
                            <div className={this.state.open ? 'Collapsible' : 'Collapsible closed'} onClick={(e) => this.togglePanel(e)}><span className="Collapsible__trigger">Filter options</span><span className="arrowimage">{arrowdown}</span></div>
                            <div className={this.state.open ? 'filteroptions-blk options-blk filter-active' : 'filteroptions-blk options-blk'}>
                                {/* <form onSubmit={this.submit}> */}
                                <div className="filter-row-blk">
                                    <div className="col-8">
                                        <div className="filteroptions-row">
                                            {selectedOption.value != 'credit_lead_return_resason_report' ?
                                                <div className="col-3">
                                                    <label>Present Date Range</label>
                                                    <Select
                                                        onChange={this.presentDatehandleChange}
                                                        options={daterangeOptions}
                                                        className="custom-select"
                                                        label={daterangeoption}
                                                        defaultValue={daterangeoption}
                                                        value={this.state.daterangeoption}
                                                        isDisabled={selectedOption.value == 'interaday_external_partner_lead_detailed_report' || 'intraday_linkout_lead_detail_report'}

                                                    />
                                                </div>
                                                : ''}
                                            {!['credit_lead_return_resason_report','interaday_external_partner_lead_detailed_report', 'intraday_linkout_lead_detail_report'].includes(selectedOption.value) ?
                                                <div className="col-3">
                                                    <label>Lead Create Start Date</label>
                                                    <div className="datepicker disabled">
                                                        <DatePicker name="startDateTime" dateFormat="yyyy/MM/dd" selected={this.state.startDate} onChange={date => this.handleDateChange('startDateTime', date)} />
                                                        {this.state.error_msg ? <span className="date-error-msg">Start Date should be less than End Date</span> : ''}
                                                    </div>
                                                </div>
                                                : ''}


                                            {/* {selectedOption.value == 'interaday_external_partner_lead_detailed_report' ?
                                            <div className="col-3">
                                                <label>Site</label>
                                                <Select
                                                    value={sites}
                                                    onChange={this.siteshandleChange}
                                                    options={sites_}
                                                    className="custom-select"
                                                    label={sites}
                                                    isMulti
                                                    isClearable
                                                    
                                                />                                 
                                            </div>
                                        : ''} */}

                                        </div>
                                        <div className="filteroptions-row">
                                            {selectedOption.value != 'credit_lead_return_resason_report' ?
                                                <div className="col-3">
                                                    <label>Medium</label>
                                                    <Select
                                                        value={medium}
                                                        onChange={this.mediumhandleChange}
                                                        options={medium_}
                                                        className="custom-select"
                                                        label={medium}
                                                        isMulti
                                                        isClearable

                                                    />
                                                </div>
                                                : ''}
                                            {(selectedOption.value != 'credit_lead_return_resason_report') && (selectedOption.value != 'interaday_external_partner_lead_detailed_report') && (selectedOption.value != 'intraday_linkout_lead_detail_report') ?
                                                <div className="col-3">
                                                    <label>Lead Create End Date</label>
                                                    <div className="datepicker disabled">
                                                        <DatePicker name="EndDateTime" dateFormat="yyyy/MM/dd" selected={this.state.endDate} onChange={date => this.handleDateChange('EndDateTime', date)} />
                                                        {/* {this.state.error_end_msg ? <span className="date-error-msg">End Date should be greater than Start Date</span> : ''} */}
                                                    </div>
                                                </div>
                                                : ''}
                                        </div>
                                        <div className="filteroptions-row">
                                            {selectedOption.value == 'external_partner_lead_detailed_report' || selectedOption.value == 'interaday_external_partner_lead_detailed_report' ?
                                                <div className="col-3">
                                                    <label>Offer Type</label>
                                                    <Select
                                                        value={offerType}
                                                        onChange={this.offertypehandleChange}
                                                        options={offer_Type}
                                                        className="custom-select"
                                                        label={offerType}
                                                        isMulti
                                                        isClearable
                                                    />
                                                </div>
                                                : ''}
                                            <div className="col-3">
                                                <label>Source (Provider)</label>
                                                {/* <input type ="text" className = "sourceText" value={source_Provider} /> */}
                                                <Select
                                                    // value={source_Provider}
                                                    // onChange={this.sourceProviderhandleChange}
                                                    options={source_Provider}
                                                    className="custom-select"
                                                    //label={source_Provider}
                                                    defaultValue={{ label: source_Provider, value: source_Provider }}
                                                    isDisabled
                                                />
                                            </div>
                                            {selectedOption.value == 'credit_lead_return_resason_report' ?
                                                <div className="col-3">
                                                    <label>Month</label>
                                                    <div className="datepicker">
                                                        <DatePicker dateFormat="yyyy/MM" showMonthYearPicker selected={this.state.selectMonth} name="selectMonth" onChange={date => this.handleMonthChange('selectMonth', date)} />
                                                    </div>
                                                </div>
                                                : ''}

                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div className="col-3">
                                            <button className="subscribe-btn" id="formElem" onClick={this.showReportshandleClick}>Show Report</button>
                                            <Link to="" className="subscribe-btn" onClick={this.subscribebtn}>Subscribe</Link>
                                            {/* <button className="subscribe-btn" ></button> */}
                                        </div>
                                    </div>
                                </div>
                                {/* </form> */}
                            </div>

                        </div>

                        {selectedOption.value != 'external_partner_lead_summary_report' ? <label className="hidden-lbl offer-type"> {this.state.offerType != null ? (this.state.offerType.map((o, i, arr) => <span>{o.value}{i != (arr.length - 1) ? '¤' : ''}</span>)) : ''} </label> : ''}
                        <label className="hidden-lbl medium-lbl"> {this.state.medium != null ? (this.state.medium.map((o, i, arr) => <span>{o.value}{i != (arr.length - 1) ? '¤' : ''}</span>)) : ''} </label>
                        {this.state.isReportVisible ? <SearchReports {...this.state} /> : null}

                    </div>
                    : <h4 className="no-rpt-tilte">No Report selected, Please select report from List</h4>}


            </div>
        )
    }

}
export default Reports
